import { render, staticRenderFns } from "./NetaProgressbarComponent.vue?vue&type=template&id=298b9536&scoped=true&"
import script from "./NetaProgressbarComponent.vue?vue&type=script&lang=js&"
export * from "./NetaProgressbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaProgressbarComponent.vue?vue&type=style&index=0&id=298b9536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b9536",
  null
  
)

export default component.exports